<template>
  <div class="alert alert-dark mb-5">
    <h1 class="h2 text-white">
      AZ ÖN ÁLTAL MEGADOTT ADATOK ALAPJÁN A BIZTOSÍTÁSI DÍJ:
    </h1>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group row mb-2">
          <label class="col-sm-6 fw-bold"></label>
          <div class="col-sm-6">
            <input
              type="text"
              class="form-control"
              disabled
              :value="
                insuranceYearlyPrice
                  | currency({
                    symbol: currencySymbol,
                    symbolPosition: currency === 'huf' ? 'back' : 'front',
                  })
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <request-pdf-buton v-if="$store.state.page > 2" :showFromPage="3"></request-pdf-buton>
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

import RequestPdfButon from './components/RequestPdfButton.vue';
export default {
  components: {
    RequestPdfButon,
  },
  computed: {
    ...mapFields(['currency', 'insuranceYearlyPrice']),
    currencySymbol: {
      get() {
        const currencies = {huf: 'Ft', eur: '€', usd: '$'};

        return currencies[this.currency];
      },
    },
  },
};
</script>
